import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import IconButton from '@material-ui/core/IconButton';
import PlayArrow from '@material-ui/icons/PlayArrow'
import Stop from '@material-ui/icons/Stop'
import FastForward from '@material-ui/icons/FastForward'
import FastRewind from '@material-ui/icons/FastRewind'
import SkipNext from '@material-ui/icons/SkipNext'
import SkipPrevious from '@material-ui/icons/SkipPrevious'

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  disabledButton: {
    margin: theme.spacing.unit,
  },
});

class ControlButtons  extends React.Component {

  render() {
    const {
      classes,
      isPlayMode,
      buttonSize,
      enableRewind,
      enableForward,
      handleClickPlay,
      handleClickStop,
      handleClickSkipPrevious,
      handleClickFastRewind,
      handleClickFastForward,
      handleClickSkipNext
    } = this.props;

    return (
      <div className={classes.controlButtons}>
        <IconButton
          className={classes.button}
          style={buttonSize}
          onClick={handleClickSkipPrevious}
          disabled={!enableRewind}
        >
          <SkipPrevious />
        </IconButton>
        <IconButton
          className={classes.button}
          style={buttonSize}
          onClick={handleClickFastRewind}
          disabled={!enableRewind}
        >
          <FastRewind />
        </IconButton>
        {isPlayMode && (
        <IconButton
          className={classes.button}
          style={buttonSize}
          onClick={handleClickStop}
        >
          <Stop />
        </IconButton>
        )}
        {!isPlayMode && (
        <IconButton
          className={classes.button}
          style={buttonSize}
          onClick={handleClickPlay}
          disabled={!enableForward}
        >
          <PlayArrow />
        </IconButton>
        )}

        <IconButton
          className={classes.button}
          style={buttonSize}
          onClick={handleClickFastForward}
          disabled={!enableForward}
        >
          <FastForward />
        </IconButton>
        <IconButton
          className={classes.button}
          style={buttonSize}
          onClick={handleClickSkipNext}
          disabled={!enableForward}
        >
          <SkipNext />
        </IconButton>
      </div>
    );
  }
}

export default withStyles(styles)(ControlButtons);



// WEBPACK FOOTER //
// ./src/components/Common/RenjuBoardCard/ControlButtons.js